import { FloatButton, QRCode } from "antd";
import { createContext, useContext, useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { Element } from "react-scroll";
import { useGetLineUrl } from "../hooks/LineLink/customerService.hooks";
import Footer from "./components/Footer";
import Header from "./components/Header";
import TabBar from "./components/TabBar/index.2esim";
import styles from "./style.module.scss";
import "./style.scss";

const DefaultLayoutContext = createContext({
  test: "test",
  // checkLoginProcess: () => {},
  // setCheckLoginProcess: () => {},
});
// let checkLoginProcess = () => {};

const Layout = (props: any) => {
  const [isMobile, setIsMobile] = useState(false);
  const [lineUrl, setLineUrl] = useState("");
  const { navType } = props;
  // console.log("navType", navType);
  const { pathname, search } = useLocation();
  const { data: customerService } = useGetLineUrl({});
  const handleWindowSizeChange = () => {
    if (window.innerWidth < 768) {
      setIsMobile(true);
    } else {
      setIsMobile(false);
    }
  };

  const getLineUrl = () => {
    const url = customerService?.filter((u: any) => u.name === "line_link");
    if (url) {
      setLineUrl(url[0]?.value);
    }
  };

  useEffect(() => {
    window.addEventListener("resize", handleWindowSizeChange);
    return () => {
      window.removeEventListener("resize", handleWindowSizeChange);
    };
  }, []);

  useEffect(() => {
    const contentContainer = document.getElementById("contentContainer");
    contentContainer?.scrollTo(0, 0);
  }, [pathname, search]);

  useEffect(() => {
    getLineUrl();
  }, [customerService]);

  useEffect(() => {
    handleWindowSizeChange();
  }, []);

  return (
    <DefaultLayoutContext.Provider value={{ test: "test" }}>
      <div
        className={styles.main}
        style={{
          overflow: "scroll",
          height: navType.doNotInitWindowHeight
            ? ""
            : "calc(var(--vh, 1vh) * 100)", //vh * 100,
          margin: "0 auto",
        }}
      >
        {navType.hideHeader ? (
          <></>
        ) : (
          <Header hideMenu={navType.hideHeaderMenu} />
        )}
        <Element
          name="layoutEl"
          className={styles.container}
          style={
            navType.backgroundColor
              ? { background: navType.backgroundColor }
              : {}
          }
          id="contentContainer"
        >
          {props.children}
          {isMobile && <TabBar />}
          {navType.hideFooter ? <></> : <Footer />}
        </Element>
        {navType.hideFloatButton ? (
          <></>
        ) : (
          <FloatButton.Group
            trigger="click"
            description={
              <img
                src="/images/otherLogo/line.png"
                alt="line"
                style={{ width: "40px", height: "40px" }}
              />
            }
            className="home-line-float-button"
            icon=""
            closeIcon=""
            onClick={(e) => {
              if (isMobile) {
                e.preventDefault();
                window.open(lineUrl, "_blank");
                return;
              }
            }}
          >
            {isMobile ? (
              ""
            ) : (
              <div className={styles.lineContainer}>
                <div className={styles.header}>
                  <img
                    src="/images/otherLogo/line.png"
                    alt="line logo"
                    style={{ height: "32px", width: "32[x" }}
                  />
                  LINE
                </div>
                <div className={styles.qrCodeBox}>
                  <QRCode value={lineUrl} size={240} />
                  <span
                    style={{
                      textDecoration: "underline",
                      color: "var(--primary500)",
                      cursor: "pointer",
                    }}
                    onClick={() => window.open(lineUrl, "_blank")}
                  >
                    {lineUrl}
                  </span>
                </div>
              </div>
            )}
          </FloatButton.Group>
        )}
      </div>
    </DefaultLayoutContext.Provider>
  );
};
export default Layout;

export const useDefaultLayout = () => {
  const LayoutContext = useContext(DefaultLayoutContext);
  return LayoutContext;
};
